"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@canonical/react-components");
var _IconCard = _interopRequireDefault(require("./IconCard"));
var _InnerCard = _interopRequireDefault(require("./InnerCard"));
require("./PackageCard.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PackageCard(_ref) {
  let {
    data,
    isBundle,
    isHighlighted,
    showFeaturedPackages,
    showIcon,
    showLibraries,
    showPlatforms,
    showRatings,
    showVerification,
    showChannel,
    highlightColor
  } = _ref;
  const innerCardProps = {
    isBundle: isBundle,
    showFeaturedPackages: showFeaturedPackages,
    showLibraries: showLibraries,
    showPlatforms: showPlatforms,
    showRatings: showRatings,
    showVerification: showVerification,
    showChannel: showChannel
  };
  const outerCardStyle = {
    height: "100%"
  };
  if (isHighlighted) {
    outerCardStyle["borderTop"] = `3px solid ${highlightColor || "#f2a031"}`;
  }
  if (isBundle) {
    outerCardStyle["borderTop"] = "3px solid #0f95a1";
  }
  const handleClick = () => {
    window.location.href = `/${data.package.name}`;
  };
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Card, {
    style: outerCardStyle,
    onClick: handleClick,
    className: "u-no-margin--bottom"
  }, showIcon ? /*#__PURE__*/_react.default.createElement(_IconCard.default, {
    iconUrl: data.package.icon_url || "https://assets.ubuntu.com/v1/be6eb412-snapcraft-missing-icon.svg"
  }, /*#__PURE__*/_react.default.createElement(_InnerCard.default, _extends({
    data: data
  }, innerCardProps, {
    height: "100%"
  }))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "u-no-margin--bottom",
    style: {
      height: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement(_InnerCard.default, _extends({
    data: data
  }, innerCardProps))));
}
PackageCard.propTypes = {
  isBundle: _propTypes.default.bool,
  isHighlighted: _propTypes.default.bool,
  showFeaturedPackages: _propTypes.default.bool,
  showIcon: _propTypes.default.bool,
  showLibraries: _propTypes.default.bool,
  showPlatforms: _propTypes.default.bool,
  showRatings: _propTypes.default.bool,
  showVerification: _propTypes.default.bool,
  showChannel: _propTypes.default.bool,
  highlightColor: _propTypes.default.string
};
var _default = exports.default = PackageCard;